<div [hidden]="emptyCart" *ngFor="let orderLine of orderLines">
  <vc-floating-cart-product
    [hidden]="hiddenProduct && hiddenProduct[orderLine.product.id]"
    [id]="'product-' + orderLine.product.id"
    [orderLine]="orderLine"
    (onRemove)="onRemove($event)"
    (resetBox)="resetBox($event)"
  ></vc-floating-cart-product>
</div>
